import axios from 'axios';

export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor for adding auth token
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for handling errors
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        const { status } = error.response || {};

        if (status === 401) {
            // Handle unauthorized access
            localStorage.removeItem('token');
            // Check if we are not already on login
            if (!window.location.pathname.includes('/login')) {
                window.location.href = '/login';
            }
        } else if (status === 403) {
            window.location.href = '/error/403';
        } else if (status === 404) {
            // Only redirect to error page if it's a direct API call that expected data
            // but for GET requests that fail, we might want to handle it in the component
        } else if (status === 500) {
            window.location.href = '/error/500';
        } else if (status === 503 || error.code === 'ERR_NETWORK' || error.message?.includes('network')) {
            window.location.href = '/error/503';
        }

        return Promise.reject(error);
    }
);

export default apiClient;
